/* eslint-disable */
// @ts-ignore
// @ts-nocheck
import React from "react";
import { Form } from "@carbon/react";

export default (props) => {
  return <Form {...props} />;
};
